var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscoverCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 127 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33331 6V75.6744C4.33331 77.1447 5.52967 78.3411 6.99998 78.3411H80.976C101.689 78.3411 118.48 61.5507 118.48 40.8373C118.48 20.124 101.689 3.33333 80.976 3.33333H6.99998C5.52967 3.33333 4.33331 4.52933 4.33331 6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_817_612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 122,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.48 40.8373C118.48 61.5507 101.689 78.3411 80.976 78.3411H7C5.52969 78.3411 4.33333 77.1452 4.33333 75.6744V6C4.33333 4.52933 5.52969 3.33333 7 3.33333H80.976C101.689 3.33333 118.48 20.124 118.48 40.8373ZM120.456 2H7C4.79063 2 3 3.79066 3 6V75.6744C3 77.8837 4.79063 79.6744 7 79.6744H120.456C122.665 79.6744 124.456 77.8837 124.456 75.6744V6C124.456 3.79066 122.665 2 120.456 2Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_817_612)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_817_612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -9,
    y: -32,
    width: 145,
    height: 145
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.779 40.8373C135.779 80.6285 103.522 112.886 63.7307 112.886C23.9391 112.886 -8.31824 80.6285 -8.31824 40.8373C-8.31824 1.04532 23.9391 -31.212 63.7307 -31.212C103.522 -31.212 135.779 1.04532 135.779 40.8373Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_817_612)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3588 139.257L-34.6896 14.4653L90.1021 -57.5827L162.151 67.2093L37.3588 139.257Z",
    fill: "#E2421B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6645 141.519L-33.3839 16.7267L91.4078 -55.3213L163.456 69.4707L38.6645 141.519Z",
    fill: "#E2431B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9702 143.78L-32.0782 18.988L92.7135 -53.06L164.763 71.732L39.9702 143.78Z",
    fill: "#E3441B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2759 146.043L-30.7725 21.2507L94.0193 -50.7987L166.068 73.9933L41.2759 146.043Z",
    fill: "#E3451B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5817 148.304L-29.4667 23.512L95.325 -48.536L167.373 76.2551L42.5817 148.304Z",
    fill: "#E4461A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8875 150.566L-28.1609 25.7733L96.6307 -46.2747L168.68 78.5165L43.8875 150.566Z",
    fill: "#E4471A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1932 152.827L-26.8552 28.0347L97.9364 -44.0133L169.985 80.778L45.1932 152.827Z",
    fill: "#E5471A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4989 155.088L-25.5495 30.296L99.2421 -41.752L171.291 83.04L46.4989 155.088Z",
    fill: "#E5481A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8046 157.35L-24.2438 32.5587L100.548 -39.4907L172.596 85.3015L47.8046 157.35Z",
    fill: "#E5491A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1104 159.612L-22.938 34.82L101.854 -37.2293L173.903 87.5629L49.1104 159.612Z",
    fill: "#E64A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4161 161.873L-21.6323 37.0813L103.159 -34.9667L175.208 89.8244L50.4161 161.873Z",
    fill: "#E64B1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7218 164.135L-20.3266 39.3427L104.465 -32.7053L176.513 92.0859L51.7218 164.135Z",
    fill: "#E74C1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0276 166.396L-19.0208 41.604L105.771 -30.444L177.82 94.3479L53.0276 166.396Z",
    fill: "#E74D1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3333 168.657L-17.7151 43.8667L107.076 -28.1827L179.125 96.6093L54.3333 168.657Z",
    fill: "#E74D1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.639 170.92L-16.4094 46.128L108.382 -25.9213L180.431 98.8708L55.639 170.92Z",
    fill: "#E84E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9448 173.181L-15.1036 48.3894L109.688 -23.66L181.736 101.132L56.9448 173.181Z",
    fill: "#E84F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2505 175.443L-13.7979 50.6507L110.994 -21.3987L183.043 103.394L58.2505 175.443Z",
    fill: "#E95019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5562 177.704L-12.4922 52.912L112.299 -19.136L184.348 105.656L59.5562 177.704Z",
    fill: "#E95119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.862 179.966L-11.1864 55.1733L113.605 -16.8747L185.653 107.917L60.862 179.966Z",
    fill: "#E95219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1677 182.227L-9.88129 57.4347L114.911 -14.6133L186.96 110.179L62.1677 182.227Z",
    fill: "#EA5319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4734 184.489L-8.57556 59.6973L116.217 -12.352L188.265 112.44L63.4734 184.489Z",
    fill: "#EA5419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7791 186.75L-7.26984 61.9587L117.522 -10.0907L189.571 114.702L64.7791 186.75Z",
    fill: "#EB5519"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0849 189.012L-5.96411 64.22L118.828 -7.82798L190.876 116.963L66.0849 189.012Z",
    fill: "#EB5619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3906 191.273L-4.65839 66.4813L120.134 -5.56668L192.183 119.225L67.3906 191.273Z",
    fill: "#EC5719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6964 193.535L-3.35263 68.7427L121.44 -3.30533L193.488 121.486L68.6964 193.535Z",
    fill: "#EC5719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1802 194.373L-2.86826 69.5813L121.923 -2.46667L193.972 122.325L69.1802 194.373Z",
    fill: "#EC5819"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.664 195.212L-2.3844 70.42L122.407 -1.62933L194.456 123.163L69.664 195.212Z",
    fill: "#EC5919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1483 196.05L-1.90057 71.2587L122.892 -0.79064L194.94 124.001L70.1483 196.05Z",
    fill: "#EC5A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6322 196.889L-1.4162 72.0973L123.375 0.0479817L195.424 124.84L70.6322 196.889Z",
    fill: "#ED5B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1161 197.726L-0.932343 72.9347L123.859 0.886671L195.908 125.679L71.1161 197.726Z",
    fill: "#ED5C18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6005 198.566L-0.448486 73.7733L124.344 1.72534L196.392 126.517L71.6005 198.566Z",
    fill: "#ED5C18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0844 199.404L0.0358887 74.612L124.828 2.56399L196.876 127.355L72.0844 199.404Z",
    fill: "#ED5D18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5688 200.243L0.519745 75.4504L125.312 3.40133L197.36 128.194L72.5688 200.243Z",
    fill: "#ED5E18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0526 201.08L1.00412 76.2889L125.796 4.24L197.844 129.032L73.0526 201.08Z",
    fill: "#ED5F18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5363 201.919L1.48798 77.1269L126.28 5.07868L198.328 129.87L73.5363 201.919Z",
    fill: "#ED6018"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0208 202.757L1.97183 77.9656L126.764 5.91734L198.812 130.709L74.0208 202.757Z",
    fill: "#EE6118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5046 203.596L2.45621 78.8041L127.248 6.75466L199.296 131.547L74.5046 203.596Z",
    fill: "#EE6218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9885 204.435L2.94006 79.6421L127.732 7.59335L199.78 132.385L74.9885 204.435Z",
    fill: "#EE6218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4729 205.272L3.42392 80.4807L128.216 8.43198L200.264 133.224L75.4729 205.272Z",
    fill: "#EE6318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9568 206.111L3.90829 81.3187L128.7 9.27067L200.748 134.062L75.9568 206.111Z",
    fill: "#EE6418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4406 206.949L4.39215 82.1572L129.184 10.1094L201.232 134.9L76.4406 206.949Z",
    fill: "#EE6517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.925 207.788L4.87601 82.9957L129.668 10.9467L201.716 135.738L76.925 207.788Z",
    fill: "#EF6617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4088 208.625L5.36038 83.8343L130.152 11.7853L202.201 136.577L77.4088 208.625Z",
    fill: "#EF6717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8926 209.464L5.84424 84.6723L130.636 12.624L202.685 137.416L77.8926 209.464Z",
    fill: "#EF6817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.377 210.303L6.32809 85.5108L131.12 13.4627L203.169 138.255L78.377 210.303Z",
    fill: "#EF6817"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8609 211.141L6.81247 86.3493L131.604 14.3L203.653 139.092L78.8609 211.141Z",
    fill: "#EF6917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3453 211.98L7.29633 87.1875L132.088 15.1387L204.137 139.931L79.3453 211.98Z",
    fill: "#EF6A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8292 212.817L7.78018 88.026L132.572 15.9773L204.621 140.769L79.8292 212.817Z",
    fill: "#EF6B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.313 213.656L8.26456 88.8645L133.056 16.816L205.105 141.608L80.313 213.656Z",
    fill: "#F06C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7969 214.495L8.74841 89.7025L133.541 17.6546L205.589 142.445L80.7969 214.495Z",
    fill: "#F06D17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2811 215.333L9.23224 90.5411L134.024 18.492L206.073 143.284L81.2811 215.333Z",
    fill: "#F06E17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.765 216.172L9.71661 91.3796L134.508 19.3307L206.557 144.123L81.765 216.172Z",
    fill: "#F06E17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2489 217.009L10.2005 92.2176L134.992 20.1693L207.041 144.961L82.2489 217.009Z",
    fill: "#F06F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7333 217.848L10.6848 93.0561L135.476 21.008L207.525 145.8L82.7333 217.848Z",
    fill: "#F07016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2172 218.687L11.1687 93.8947L135.96 21.8453L208.009 146.637L83.2172 218.687Z",
    fill: "#F17116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7016 219.525L11.6526 94.7332L136.444 22.684L208.493 147.476L83.7016 219.525Z",
    fill: "#F17216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1854 220.362L12.1369 95.5714L136.928 23.5227L208.977 148.315L84.1854 220.362Z",
    fill: "#F17316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6693 221.201L12.6208 96.4099L137.412 24.3613L209.461 149.154L84.6693 221.201Z",
    fill: "#F17416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1535 222.04L13.1046 97.2484L137.897 25.2L209.945 149.992L85.1535 222.04Z",
    fill: "#F17416"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6374 222.879L13.589 98.0864L138.381 26.0374L210.429 150.829L85.6374 222.879Z",
    fill: "#F17516"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1213 223.717L14.0729 98.9249L138.865 26.876L210.913 151.668L86.1213 223.717Z",
    fill: "#F27616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6057 224.555L14.5567 99.7635L139.349 27.7147L211.397 152.507L86.6057 224.555Z",
    fill: "#F27716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0896 225.393L15.0411 100.601L139.833 28.5533L211.881 153.345L87.0896 225.393Z",
    fill: "#F27816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5734 226.232L15.525 101.44L140.317 29.392L212.365 154.183L87.5734 226.232Z",
    fill: "#F27916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0578 227.071L16.0088 102.279L140.801 30.2293L212.849 155.021L88.0578 227.071Z",
    fill: "#F27A16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5417 227.908L16.4932 103.117L141.285 31.068L213.333 155.86L88.5417 227.908Z",
    fill: "#F27B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0254 228.747L16.977 103.955L141.769 31.9067L213.817 156.699L89.0254 228.747Z",
    fill: "#F27B15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5098 229.585L17.4614 104.794L142.253 32.7453L214.301 157.537L89.5098 229.585Z",
    fill: "#F37C15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9937 230.424L17.9453 105.632L142.737 33.5827L214.785 158.374L89.9937 230.424Z",
    fill: "#F37D15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4781 231.262L18.4292 106.47L143.221 34.4213L215.269 159.213L90.4781 231.262Z",
    fill: "#F37E15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.962 232.1L18.9136 107.309L143.705 35.26L215.753 160.052L90.962 232.1Z",
    fill: "#F37F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4458 232.938L19.3973 108.147L144.189 36.0987L216.237 160.891L91.4458 232.938Z",
    fill: "#F38015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9302 233.777L19.8812 108.985L144.673 36.9373L216.721 161.728L91.9302 233.777Z",
    fill: "#F38115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.414 234.616L20.365 109.824L145.157 37.7747L217.205 162.567L92.414 234.616Z",
    fill: "#F48215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8978 235.453L20.8494 110.662L145.641 38.6133L217.689 163.405L92.8978 235.453Z",
    fill: "#F48215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3822 236.292L21.3333 111.5L146.125 39.452L218.173 164.244L93.3822 236.292Z",
    fill: "#F48315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8661 237.131L21.8177 112.339L146.609 40.2907L218.657 165.083L93.8661 237.131Z",
    fill: "#F48415"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.35 237.969L22.3016 113.177L147.093 41.128L219.141 165.92L94.35 237.969Z",
    fill: "#F48515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8344 238.808L22.7854 114.016L147.577 41.9667L219.627 166.759L94.8344 238.808Z",
    fill: "#F48615"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3182 239.645L23.2697 114.854L148.061 42.8054L220.111 167.597L95.3182 239.645Z",
    fill: "#F58715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8021 240.484L23.7536 115.693L148.545 43.644L220.595 168.436L95.8021 240.484Z",
    fill: "#F58814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2864 241.323L24.2374 116.531L149.029 44.4827L221.079 169.274L96.2864 241.323Z",
    fill: "#F58914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7702 242.161L24.7218 117.369L149.513 45.3213L221.563 170.112L96.7702 242.161Z",
    fill: "#F58A14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2541 243L25.2057 118.208L149.997 46.1587L222.047 170.95L97.2541 243Z",
    fill: "#F58A14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7385 243.837L25.6896 119.046L150.481 46.9973L222.531 171.789L97.7385 243.837Z",
    fill: "#F58B14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.2224 244.676L26.174 119.884L150.965 47.836L223.015 172.628L98.2224 244.676Z",
    fill: "#F58C14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7068 245.515L26.6578 120.723L151.449 48.6733L223.499 173.466L98.7068 245.515Z",
    fill: "#F68D14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1906 246.354L27.1417 121.561L151.933 49.512L223.983 174.304L99.1906 246.354Z",
    fill: "#F68E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6745 247.191L27.626 122.399L152.417 50.3507L224.467 175.143L99.6745 247.191Z",
    fill: "#F68F14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.158 248.029L28.1098 123.238L152.901 51.1893L224.951 175.981L100.158 248.029Z",
    fill: "#F69014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.643 248.868L28.5937 124.076L153.385 52.028L225.435 176.82L100.643 248.868Z",
    fill: "#F69114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.126 249.707L29.0781 124.915L153.869 52.8667L225.919 177.657L101.126 249.707Z",
    fill: "#F69114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.61 250.545L29.562 125.753L154.353 53.704L226.403 178.496L101.61 250.545Z",
    fill: "#F79214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.095 251.383L30.0464 126.591L154.837 54.5427L226.887 179.335L102.095 251.383Z",
    fill: "#F79314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.579 252.221L30.5302 127.43L155.323 55.3813L227.371 180.173L102.579 252.221Z",
    fill: "#F79413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.063 253.06L31.014 128.268L155.807 56.2187L227.855 181.011L103.063 253.06Z",
    fill: "#F79513"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.547 253.899L31.4984 129.106L156.291 57.0573L228.339 181.849L103.547 253.899Z",
    fill: "#F79613"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1088 44.8093C16.0974 45.7227 14.7828 46.1213 12.7036 46.1213H11.839V35.2067H12.7036C14.7828 35.2067 16.0453 35.5787 17.1088 36.5413C18.2229 37.5333 18.8912 39.068 18.8912 40.6493C18.8912 42.2347 18.2229 43.8187 17.1088 44.8093ZM13.3484 32.4093H8.62238V48.916H13.3229C15.8224 48.916 17.6281 48.3267 19.2125 47.0093C21.0953 45.4507 22.2084 43.1027 22.2084 40.6747C22.2084 35.8027 18.5693 32.4093 13.3484 32.4093Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6907 48.916H26.9093V32.4093H23.6907V48.916Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7818 38.744C32.8495 38.028 32.2823 37.5573 32.2823 36.6653C32.2823 35.6253 33.2932 34.836 34.6807 34.836C35.6459 34.836 36.438 35.232 37.2771 36.1733L38.962 33.9667C37.5771 32.756 35.9208 32.1373 34.112 32.1373C31.1912 32.1373 28.9636 34.1653 28.9636 36.8667C28.9636 39.14 30.0011 40.304 33.0251 41.392C34.2844 41.8373 34.926 42.1333 35.25 42.3333C35.8927 42.752 36.2156 43.3467 36.2156 44.04C36.2156 45.3773 35.1522 46.368 33.7151 46.368C32.1807 46.368 30.9432 45.6013 30.2022 44.168L28.1219 46.1693C29.6052 48.3467 31.3864 49.312 33.8364 49.312C37.1823 49.312 39.5298 47.088 39.5298 43.8933C39.5298 41.2693 38.4448 40.0826 34.7818 38.744Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5448 40.6747C40.5448 45.5253 44.3547 49.2867 49.2573 49.2867C50.6427 49.2867 51.8292 49.0147 53.2932 48.3267V44.536C52.0057 45.824 50.8656 46.3427 49.4063 46.3427C46.1636 46.3427 43.8625 43.992 43.8625 40.6493C43.8625 37.4813 46.2375 34.9813 49.2573 34.9813C50.7921 34.9813 51.9557 35.5293 53.2932 36.8387V33.0506C51.8803 32.3333 50.7183 32.0373 49.3328 32.0373C44.4557 32.0373 40.5448 35.8747 40.5448 40.6747Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8208 43.496L74.4177 32.4093H70.9016L77.9057 49.34H79.6385L86.7693 32.4093H83.2787L78.8208 43.496Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.224 48.916H97.3552V46.1213H91.4421V41.6653H97.136V38.8693H91.4421V35.2067H97.3552V32.4093H88.224V48.916Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M103.644 40.0093H102.702V35.0093H103.694C105.7 35.0093 106.79 35.8493 106.79 37.456C106.79 39.116 105.7 40.0093 103.644 40.0093ZM110.104 37.2827C110.104 34.192 107.974 32.4093 104.261 32.4093H99.4875V48.916H102.702V42.2853H103.123L107.58 48.916H111.539L106.342 41.9613C108.768 41.468 110.104 39.8107 110.104 37.2827Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112.057 33.4734H111.997V33.0934H112.06C112.232 33.0934 112.321 33.1547 112.321 33.28C112.321 33.4093 112.231 33.4734 112.057 33.4734ZM112.669 33.276C112.669 32.9854 112.469 32.8267 112.118 32.8267H111.651V34.2813H111.997V33.7173L112.405 34.2813H112.829L112.351 33.6813C112.555 33.6267 112.669 33.4774 112.669 33.276Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.182 34.5946C111.626 34.5946 111.171 34.1307 111.171 33.5533C111.171 32.9733 111.622 32.5106 112.182 32.5106C112.736 32.5106 113.187 32.984 113.187 33.5533C113.187 34.1253 112.736 34.5946 112.182 34.5946ZM112.187 32.2826C111.481 32.2826 110.92 32.8466 110.92 33.5506C110.92 34.256 111.487 34.8213 112.187 34.8213C112.876 34.8213 113.441 34.2493 113.441 33.5506C113.441 32.856 112.876 32.2826 112.187 32.2826Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_817_612",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 31,
    width: 18,
    height: 19
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0719 49.388C58.2479 49.388 54.336 45.476 54.336 40.652C54.336 40.652 54.336 40.652 54.336 40.64C54.336 38.24 55.3079 36.056 56.8803 34.484C56.8803 34.472 56.8921 34.472 56.8921 34.46C56.9041 34.46 56.9041 34.448 56.9161 34.448C58.488 32.876 60.6719 31.904 63.0719 31.904C63.0839 31.904 63.0839 31.904 63.0839 31.904C67.9079 31.904 71.8197 35.816 71.8197 40.64C71.8197 40.652 71.8197 40.652 71.8197 40.652C71.8197 43.052 70.8479 45.224 69.276 46.808C69.276 46.82 69.264 46.82 69.264 46.832C69.2521 46.832 69.2521 46.844 69.2401 46.844C67.6563 48.416 65.4839 49.388 63.0839 49.388C63.0839 49.388 63.0839 49.388 63.0719 49.388Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_817_612)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.7867,
    y: 31.372,
    width: 18.6933,
    height: 18.6933,
    fill: "url(#pattern0_817_612)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_817_612",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_817_612",
    transform: "scale(0.0172414)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_817_612",
    width: 58,
    height: 58,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscoverCard);
export default __webpack_public_path__ + "static/media/Discover-card.9384c68f.svg";
export { ForwardRef as ReactComponent };